import { notifications } from '@mantine/notifications';

export function showSuccessToast(message: string) {
  notifications.show({
    message,
    color: 'teal',
    autoClose: 3000,
  });
}

export function showErrorToast(message: string) {
  notifications.show({
    message,
    color: 'red',
    autoClose: 5000,
  });
}
